module.exports = function getResource(label, vars = []) {
    const resources = {
        unsubscribeModalConfirmTitle: 'Désabonné',
        unsubscribeModalConfirmMsg: 'Vous avez réussi à vous désabonner de votre article à réapprovisionnement automatique.',
        unsubscribeModalConfirmButtonText: 'Terminé',
        errorMessage: 'Oups! Un problème est survenu et nous n’avons pas été en mesure de traiter vos modifications. Veuillez réessayer plus tard.',
        manageSubscription: 'Gérer l’abonnement',
        unsubscribeItem: 'Se désabonner de l’article',
        updateSubscriptionError: 'Mettre à jour l’abonnement',
        pausedSubscriptionModalConfirmTitle: 'Article en pause',
        pausedSubscriptionModalConfirmMsg: 'Le réapprovisionnement automatique de cet article a été mis en pause. Vous pouvez sélectionner « Reprendre » à tout moment pour reprendre la livraison.',
        pausedSubscriptionModalConfirmButtonText: 'Terminé',
        skipItemUnavailable: '« Sauter l’article » n’est pas disponible',
        skipedSubscriptionModalConfirmTitle: 'Article sauté',
        nextShipmentText: 'Le réapprovisionnement automatique de votre article sautera la prochaine livraison et reprendra le',
        pause: 'En pause',
        resumeItem: 'Reprendre l’article',
        deleteCard: 'Supprimer la carte',
        addNewCard: 'Ajoutez une nouvelle carte de crédit ou de débit',
        editCard: 'Modifier la carte de crédit ou de débit',
        pauseItem: 'Mettre l’article en pause',
        addressRemovalModalTitle: 'Supprimer l’adresse',
        addressRemovalModalBody: 'Êtes-vous sûr(e) de vouloir supprimer cette adresse?',
        addressRemovalModalConfirmButtonText: 'Supprimer l’adresse',
        addressRemovalModalFailureButtonText: 'OK',
        addressRemovalModalBodyFailure: 'Impossible de supprimer l’adresse. Cette adresse est utilisée en tant que\n' +
            'votre adresse pour un abonnement. Pour la supprimer, changez l’adresse liée à l’abonnement.',
        limitReachedTitle: 'Maximum atteint',
        limitReachedBody: 'Veuillez supprimer l’une de vos adresses enregistrées avant d’en ajouter une nouvelle.',
        limitReachedConfirmButtonText: 'OK',
        orderConfirmationTitle: 'Confirmation de la commande',
        orderConfirmationBody: `Merci! Votre numéro de commande est #${vars[0]}. Vous recevrez un courriel de confirmation au <b>${vars[1]}</b>`,
        orderConfirmationConfirmButtonText: 'Compris',
        orderConfirmationErrorTitle: 'Erreur dans la passation de commande',
        orderNowTooSoonTitle: 'Il est trop tôt pour faire le plein',
        orderNowTooSoonBody: `Vous avez déjà passé une commande avec livraison immédiate au cours des ${vars[0]} derniers jours. Revenez dans ${vars[1]} jours pour commander à nouveau.`
    };
    return resources[label];
};
